import { Grid } from "react-feather";
import { Btn, H5, H6, Image, LI, P, UL } from "../../../../AbstractElements";
import { FREE, PricingPlan, Selected, TrialVersion } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";

const PricingPlans = () => {
  return (
    <UL className="simple-list">
      <LI>
        <Btn outline color="primary">
          <Grid />
          {PricingPlan}
        </Btn>
      </LI>
      <LI>
        <div className="pricing-plan">
          <H6>{TrialVersion} </H6>
          <H5>{FREE}</H5>
          <P>{"100GB Space"}</P>
          <Btn size="xs" color="primary" outline>
            {Selected}
          </Btn>
          <Image className="bg-img" src={dynamicImage(`dashboard/folder.png`)} alt="dashboard" />
        </div>
      </LI>
    </UL>
  );
};

export default PricingPlans;
